import React, { useState } from "react";
import "./RejectApplicationModal.css";
import close from "../../Assets/close.svg";

const RejectApplicationModal = ({ onClose, onReject }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleReject = () => {
    if (reason.length < 250) {
      setError("Reason must be at least 250 characters long");
      return;
    }
    onReject(reason);
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
    if (error && e.target.value.length >= 250) {
      setError("");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="reject-modal">
        <button className="close-btn" onClick={onClose}>
          <img src={close} alt="" />
        </button>
        <h3 className="heading">REJECT APPLICATION?</h3>
        
        <p className="sub-heading">Write your reason for cancellation</p>
        
        <textarea
          value={reason}
          onChange={handleReasonChange}
          placeholder="Please provide a detailed reason for cancellation (minimum 250 characters)"
          rows={6}
          style={{
            width: "90%",
            padding: "10px",
            border: error ? "1px solid red" : "1px solid #ccc",
            borderRadius: "4px",
            resize: "vertical",
            fontFamily: "inherit",
            fontSize: "14px"
          }}
        />
        
        <div style={{ marginTop: "5px", fontSize: "12px", color: "#666" }}>
          {reason.length}/250 characters minimum
        </div>
        
        {error && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
            {error}
          </div>
        )}

        <div className="modal-footer">
          <button className="go-back" onClick={onClose}>Go Back</button>
          <button className="reject" onClick={handleReject}>Reject</button>
        </div>
      </div>
    </div>
  );
};

export default RejectApplicationModal;
